import React from 'react';
import { useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';

const Welcome = () => {
    const { user } = useSelector((state) => state.account);
    return (
        <Container>
            {user && (
                <div className="d-flex justify-content-center align-items-center welcome">
                    <p className="welcome__text">
                        {`Witaj${user.name ? ', ' : '!'} `}
                        {user.name && <span>{`${user.name}`}</span>}
                    </p>
                </div>
            )}
        </Container>
    );
};

export default Welcome;
